import React from 'react'

import Select from 'Components/Select'
import Grid from '@material-ui/core/Grid'

export default React.memo(props => <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                                         alignItems={'center'}>
    <Grid item xs style={{ margin: 0, padding: 0 }}>
      <Select
        style={props.style}
        inline={props.inline} title={props.title}
        disabled={props.disabled || false}
        options={props.options} onChange={props.onChange}
        value={props.data !== undefined && props.data.id}/>
    </Grid>
    <Grid item>
      <button type="button" onClick={props.onClickComboSimpleBool}
              disabled={props.disabled || false}
              className={'fa fa-' + (props.data !== undefined && (props.data.valeur_bool === true || props.data.valeur_bool === 1 || parseInt(props.data.valeur_bool) === 1) ? 'check-circle-o text-success' : 'times-circle-o text-danger')}
      />
    </Grid>
  </Grid>
)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboSimpleBool.js